/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/sales";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/sales";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// URLS ///
import { url_prefix } from "settings";
/// TYPES ///
import { User } from "api/types/authentication";

const sales_url: string = "sales";
const sales_data_url: string = "sales_data";

export const getSalesData = () => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${sales_data_url}`;

    try {
      const { data } = await axios.get(url, config);

      dispatch({
        type: ActionType.GET_SALES_DATA,
        sales: data
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
          console.log(err);
          if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}

export const createSale = (sold_user: User) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;
    dispatch({
      type: AuthActionType.REGISTER_PENDING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${sales_url}/`;

    try {
      const { data } = await axios.post(url, sold_user, config);

      dispatch({
        type: ActionType.CREATE_SALE,
        sale: data
      });

      dispatch({
        type: AuthActionType.REGISTER_SUCCESS,
        payload: data
      });

    }
    catch (err) {
      if (err instanceof AxiosError && err?.response?.status === 401) {
        dispatch({
          type: AuthActionType.REGISTER_FAIL,
          payload: "You have been logged out, please log back into the system",
          offer_reset: false
        });
        dispatch({
          type: AuthActionType.AUTH_FAILED,
        });
      }
      else if (err instanceof AxiosError && err?.response) {
        dispatch({
          type: AuthActionType.REGISTER_FAIL,
          payload: err?.response?.data?.error ?? "",
          offer_reset: true
        });
      }
    }
  }
}
